import type { TruckHistory } from "./truckHistory";

export interface Truck {
  _id: string;
  licensePlate: string;
  type: string;
  currentState: {
    location: {
      cityId: string;
    };
    destination?: {
      cityId: string;
    };
    status: TruckStatus;
    timestamp: string;
  };
  createdAt: string;
  updatedAt: string;
  history?: TruckHistory[];
  retired: boolean;
  suggestedDriverId?: string;
  initiallyCreatedFrom?: "MANUAL" | "LOGISLY";
  initialLogislyRef?: {
    entityType?: string;
    externalId?: string;
    label?: string;
  };
}

export enum TruckStatus {
  ON_WORK = "ON_WORK",
  STANDBY = "STANDBY",
  MAINTENANCE = "MAINTENANCE",
  MOB = "MOB",
  UNKNOWN = "UNKNOWN",
  RETIRED = "RETIRED",
}

export interface TruckResponse {
  data: {
    trucks: Truck[];
    pagination: {
      page: number;
      pageSize: number;
      total: number;
      totalPages: number;
      sortBy: string;
      sortOrder: string;
    };
  };
}

export interface TruckSearchFilters {
  licensePlate?: string;
  status?: string;
  cityId?: string;
  type?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  truckGroupId?: string;
  page?: number;
  pageSize?: number;
}

// Mapper functions
export const mapTruckResponse = (response: any): Truck => {
  return {
    _id: response._id,
    licensePlate: response.licensePlate || "",
    type: response.type || "",
    currentState: {
      location: {
        cityId: response.currentState?.location?.cityId || "",
      },
      destination: response.currentState?.destination
        ? {
            cityId: response.currentState.destination.cityId,
          }
        : undefined,
      status:
        TruckStatus[response.currentState?.status as keyof typeof TruckStatus] ||
        (response.retired ? TruckStatus.RETIRED : TruckStatus.UNKNOWN),
      timestamp: response.currentState?.timestamp || new Date().toISOString(),
    },
    createdAt: response.createdAt || new Date().toISOString(),
    updatedAt: response.updatedAt || new Date().toISOString(),
    history: [response],
    retired: response.retired || false,
    suggestedDriverId: response.suggestedDriverId,
    initiallyCreatedFrom: response.initiallyCreatedFrom || "MANUAL",
    initialLogislyRef: response.initialLogislyRef,
  };
};

export const mapTrucksResponse = (response: TruckResponse): Truck[] => {
  if (!response.data || !Array.isArray(response.data.trucks)) {
    return [];
  }
  return response.data.trucks.map(mapTruckResponse);
};
